import { ContentType } from '../../utils/data/constants/content-type';

type Labels = {
  article: string;
  audio: string;
  course: string;
  guide: string;
  video: string;
};

export const getContentCategory = ({
  contentType,
  labels,
}: {
  contentType: ContentType | null | number | undefined;
  labels: Labels;
}) => {
  const contentTypeToLabel: { [key: number]: keyof Labels } = {
    [ContentType.Article]: 'article',
    [ContentType.Audio]: 'audio',
    [ContentType.Course]: 'course',
    [ContentType.Guide]: 'guide',
    [ContentType.Podcast]: 'audio',
    [ContentType.Video]: 'video',
  };
  const labelKey = contentTypeToLabel[contentType ?? -1];

  return labelKey ? labels[labelKey] : '';
};
